import { FeedBackContainer } from "../../containers";
import "./style.scss";
function FeedBack() {
  return (
    <div id="feedbackPage">
      <FeedBackContainer />
    </div>
  );
}
export default FeedBack;
